import React, { useState } from 'react';
import axios from 'axios';
const API = 'https://app.recensement-enfantsnonproteges.fr';
export default function ModifierTemoignage({ onBack }) {
  const [form, setForm] = useState({ fiche_id: '', pp_email: '', nouveau_temoignage: '' });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const submit = async () => {
    if (!form.fiche_id || !form.pp_email || !form.nouveau_temoignage) { setError('Tous les champs sont obligatoires.'); return; }
    try { await axios.post(API+'/api/demandes/modification', form); setSubmitted(true); }
    catch(e) { setError('Erreur, veuillez réessayer.'); }
  };
  if (submitted) return (
    <div className="form-page">
      <div className="success-msg">
        <h3>Demande envoyée</h3>
        <p>Notre équipe va traiter votre demande. Le nouveau témoignage sera publié après validation.</p>
        <button className="btn-red" onClick={onBack}>Retour aux fiches</button>
      </div>
    </div>
  );
  return (
    <div className="form-page">
      <span className="form-back" onClick={onBack}>← Retour aux fiches</span>
      <h2>Modifier mon témoignage</h2>
      <p className="form-sub">Votre demande sera examinée par notre équipe avant publication. Anonymisez tous les noms — initiales uniquement pour toute personne identifiable, y compris l'agresseur.</p>
      <div className="field"><label className="lbl req">Numéro de fiche</label><input type="number" placeholder="ex. 12" value={form.fiche_id} onChange={e => setForm(f=>({...f,fiche_id:e.target.value}))} style={{width:'120px'}} /></div>
      <div className="field"><label className="lbl req">Votre email</label><input type="email" placeholder="email@..." value={form.pp_email} onChange={e => setForm(f=>({...f,pp_email:e.target.value}))} /></div>
      <div className="field"><label className="lbl req">Nouveau témoignage</label><textarea value={form.nouveau_temoignage} onChange={e => setForm(f=>({...f,nouveau_temoignage:e.target.value}))} placeholder="Écrivez votre nouveau témoignage..." style={{height:'150px'}} /></div>
      {error && <div className="note">{error}</div>}
      <div className="nav-btns">
        <button className="btn-prev" onClick={onBack}>← Retour</button>
        <button className="btn-submit" onClick={submit}>Envoyer la demande →</button>
      </div>
    </div>
  );
}
